export default "__VITE_ASSET__99iIGlMe__"